<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1">Glory Season</a></h1><a id="page_1">
<p class="author">David Brin</p>
<p class="fmtitle"><br/></p>
<p class="author"><img alt="images" src="image/logo.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Title.vue?d726c780